export const colors = {
  defaultBaseColor: '#3376BA',
  typographyA: '#404040',
  typographyB: 'rgba(64,64,64,.75)',
  typographyC: 'rgba(64,64,64,.5)',
  maskGrayAlpha: 'rgba(0, 0, 0, 0.3)',
  gray: '#707070',
  lightGray: '#909090',
  veryLightGray: '#A0A0A0',
  darkWhite: '#F0F0F0',
  offWhite: '#FAFAFA',
  fieldLabel: 'rgba(0, 0, 0, 0.54)',
  borderColor: 'rgba(0, 0, 0, 0.25)',
}

export const stringToColor = (string: string) => {
  let hash = 0
  let i

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
  }

  let color = '#'

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }

  return color
}
